import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { useRouter } from "next/router";

import MainTemplate from "@/components/Templates/MainTemplate";
import { FlexDiv } from "@/components/Atoms/Box";
import Button from "@/components/Atoms/Button";
import Testimonials from "@/components/Organisms/Testimonials";
import BannerSection from "./BannerSection";
import Symptoms from "./Symptoms";
import HowItWorks from "./HowItWorks";
import CardComponent from "./Cards";

import { isMobile, renderMetaTags } from "@/utils";

import { useAppDispatch, useAppSelector } from "@/hooks";

const HealthPage = (props) => {
  const { slug, urlParams, isWebinarPage = false } = props || {};
  const programType = slug;
  const dispatch = useAppDispatch();

  const history = useRouter();

  const hideRibbon = [
    "3-week-wellness-bootcamp",
    "4-week-nutrition-gut-health-program",
  ]?.includes(slug);

  const {
    data: healthDetailsData,
    isLoading,
    success,
    error,
  } = useAppSelector((state) => state.healthProgram);

  const { countryCodeData: countryCodes } = useAppSelector(
    (state) => state.dashboard
  );

  const packageReducerData = {};
  const landinPageReducerData = {};

  const [isBtnVisible, setBtnVisible] = useState(false);

  const cardRef = useRef(null);
  const callBackRef = useRef(null);
  const footerRef = useRef(null);

  useEffect(() => {
    if (isMobile) {
      setBtnVisible(true);
    }
    window.onscroll = () => {
      let callbackButton = document.getElementById("floatingCta");
      let footerPos =
        footerRef.current?.getBoundingClientRect()?.top - window.innerHeight;
      let formPosBottomPos = callbackButton?.getBoundingClientRect()?.bottom;
      let formPosTopPos =
        callbackButton?.getBoundingClientRect()?.top - window.innerHeight;
      formPosTopPos >= 0 || (formPosBottomPos <= 0 && footerPos > 0)
        ? setBtnVisible(true)
        : setBtnVisible(false);
    };
  }, []);

  const handleScrollToSection = () => {
    let cardDiv = cardRef.current;
    if (cardDiv) {
      cardDiv.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleScrollToCallBackForm = () => {
    let btn = callBackRef.current;
    if (btn) {
      btn.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  const metaTags = renderMetaTags(healthDetailsData);

  return (
    <>
      {metaTags}
      <MainTemplate
        // isLoading={isLoading}
        error={error}
        success={success}
        footerRef={footerRef}
        hideRibbon={hideRibbon}
      >
        <BannerSection
          handleScrollToSection={handleScrollToSection}
          programType={programType}
          healthDetailsData={healthDetailsData}
        />

        <HowItWorks
          urlParams={urlParams}
          programType={programType}
          countryCodes={countryCodes}
          healthDetailsData={healthDetailsData}
          callBackRef={callBackRef}
          isWebinarPage={isWebinarPage}
        />
        <Symptoms
          programType={programType}
          handleScrollToCallBackForm={handleScrollToCallBackForm}
          healthDetailsData={healthDetailsData}
          isMobile={isMobile}
        />

        {false && (
          <CardComponent
            planData={planData}
            openPaymentPage={(data) => openPaymentPage(data)}
            cardRef={cardRef}
            programType={programType}
          />
        )}
        {isBtnVisible &&
          healthDetailsData?.hero?.hero_cta_title_constant &&
          healthDetailsData?.hero?.hero_signup_primary_pricing?.price && (
            <FlexDiv>
              <FixedBtn
                variant={"primary"}
                fontFamily={"var(--font-700)"}
                fontSize={"16px"}
                onClick={() => handleScrollToCallBackForm()}
                btnPadding={"11px 50px"}
              >
                {packageReducerData.promoCodeApplied &&
                landinPageReducerData?.pageData ? (
                  <>
                    {healthDetailsData?.hero?.hero_cta_title_constant + ` `}
                    <StrikeThroughText>
                      {landinPageReducerData?.pageData?.original_price}
                    </StrikeThroughText>
                    {` ` + landinPageReducerData?.pageData?.new_price}
                  </>
                ) : (
                  `${healthDetailsData?.hero?.hero_cta_title_constant} ${healthDetailsData?.hero?.hero_signup_primary_pricing?.price}`
                )}
              </FixedBtn>
            </FlexDiv>
          )}
        {healthDetailsData?.testimonials?.testimonials?.length > 0 && (
          <Testimonials
            data={healthDetailsData?.testimonials}
            isMobile={isMobile}
          />
        )}
      </MainTemplate>
    </>
  );
};

export default HealthPage;

const FixedBtn = styled(Button)`
  display: none;
  @media only screen and (max-width: 1159px) {
    display: block;
    position: fixed;
    left: 50%;
    white-space: nowrap;
    transform: translateX(-50%);
    z-index: 999;
    bottom: 20px;
  }
`;

const StrikeThroughText = styled.del`
  font-family: inherit;
  font-size: inherit;
  color: inherit;
`;
